export function reminderMapperListResponse(json, headers) {

  let data = json.map((resource) => ({
    ...resource,
    id: resource.objectId,
    reminderId: resource.objectId,
    type: 'reminder',
    description: resource.name,
    url: '/reminder/' + resource.objectId+'/show',
    content:resource
  }))

  return {
    data,
    total: data.length,
  };
}

export function fixUpdateReminderId(json) {
  return {
    data: { ...json, id: json.objectId },
  };
}

export function fixCreateReminderId(params, json) {
  return {
    data: { ...params.data, id: json.result.objectId },
  };
}

export function fixGetManyReminder(json) {
  return {
    data: json.map((resource) => ({
      ...resource,
      id: resource.objectId,
      reminderId: resource.objectId,
    })),
  };
}

export function reminderMapperGetOneResponse(json) {
  return {
    data: { ...json.result, id: json.result.objectId, reminderId: json.result.objectId },
  };
}